export default __webpack_public_path__ + "static/media/L2L_ConnectLogo_greenblack.17e91aec.png";